import { checkPowerPlacement } from "./checkPowerPlacement";
import { DEFAULT_MATCH, NEGATIVE_MATCH, POSITIVE_MATCH } from "./types";

import type { NodeModel } from "@/models/nodes/types";
import type { NodeCondition } from "@corca/data";

export function checkNodeParentCondition(
  nodeCondition?: NodeCondition | "none" | "present",
  parent?: NodeModel,
) {
  if (nodeCondition === undefined) return true;

  if (nodeCondition === "none") {
    return !parent;
  }
  if (nodeCondition === "present") {
    return !!parent;
  }

  let current = parent;

  while (current) {
    if (current.type === "operator") {
      if (nodeCondition.hasType?.includes(`not:${current.type}:${current.operatorType}`)) {
        return false;
      }
      if (nodeCondition.hasType?.includes(`${current.type}:${current.operatorType}`)) {
        return true;
      }
    }

    const powerPlacementCheck = checkPowerPlacement(nodeCondition.hasPowerPlacement, current);

    if (powerPlacementCheck === NEGATIVE_MATCH) {
      return false;
    }
    if (powerPlacementCheck === POSITIVE_MATCH) {
      return true;
    }
    if (powerPlacementCheck === DEFAULT_MATCH) {
      return true;
    }

    if (nodeCondition.hasType?.includes(`not:${current.type}`)) {
      return false;
    }
    if (nodeCondition.hasType?.includes(current.type)) {
      return true;
    }

    current = current.parent;
  }

  const hasIncludingTypes = nodeCondition.hasType?.some((r) => !r.startsWith("not:"));

  return !hasIncludingTypes;
}
